module.exports = __webpack_public_path__ + "media/images/top-design-04-e07ec93eb6480ea33c15a6b608a37936.jpg";